
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Gutter from '@/ui-kit/components/gutter';
import {
  StyleSizeType,
  StylePositionType,
} from '@/ui-kit/styles/enums';
import WhoWeAreStoreName from '@/store/who-we-are/name';
import Card from './card';
import WhoWeAreSection from '../section';

export default {
  name: 'WhoWeAreLeadershipSection',
  components: {
    Card,
    WhoWeAreSection,
    Typography,
    Gutter,
  },
  data() {
    return {
      TypographyType,
      StyleSizeType,
      StylePositionType,
    };
  },
  computed: {
    leadershipContent() {
      return this.$store.state[WhoWeAreStoreName].leadershipContent;
    },
  },
};
